import { Link } from 'react-router-dom';

type LogoProps = {
  compact?: boolean;
};

export default function Logo({ compact = false }: LogoProps) {
  return (
    <Link to="/" className="flex items-center gap-3" aria-label="DropBridge home">
      <img
        src="/dropbridge-logo.png"
        alt="DropBridge logo"
        className={compact ? 'h-9 w-9 rounded-xl' : 'h-11 w-11 rounded-2xl'}
      />
      {!compact && (
        <span className="text-lg font-bold tracking-tight text-slate-950 dark:text-white">
          DropBridge
        </span>
      )}
    </Link>
  );
}
